module.exports = __webpack_public_path__ + "img/icon3.c2f2eec9.png";